export enum ExternalDataOperationTypeEnum {
  PAY = 0,
  FAIL_PAY = 1,
  ACCOUNT_VERIFICATION = 2,
}
